import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import MaterialIcon from '../elements/MaterialIcon.jsx';
import { dismissRejectedFoodOps } from '../../redux/actions/food';
import { describeOp } from '../../redux/food/applyOp';
import { LOAD_FAILED, NOT_PERSISTENT, rejectedHeading, selectSyncStatus, syncStatusLine } from '../../redux/food/syncStatus';

/**
 * The app shell's sync indicator (docs/local-first-food-data.md, phase 5): whether changes made here
 * are waiting to be sent, and why; the changes the server refused, each with a Dismiss; a warning
 * when the browser cannot keep them; and that the food data could not be loaded, when there is no
 * copy to show instead. Nothing at all while online with nothing to send.
 */
export default function SyncStatus() {
	const dispatch = useDispatch();
	const status = useSelector(selectSyncStatus, shallowEqual);
	const entities = useSelector((state) => (state.food ? state.food.entities : null));
	const line = syncStatusLine(status);
	const { rejected, persistent, offline, paused, sending, lastError, loadError } = status;
	if(!line && !rejected.length && persistent && loadError === null) {
		return null;
	}
	const icon = offline ? 'cloud_off' : (paused ? 'lock' : (sending ? 'cloud_upload' : 'cloud_queue'));
	// Waiting for the next try after a failure: what went wrong, on hover.
	const lineTitle = !offline && !paused && !sending && lastError ? lastError : undefined;
	return (
		<div className='sync-status' role='status' aria-live='polite'>
			{line &&
			<div className={`sync-status__line ${offline ? 'is-offline' : ''}`} title={lineTitle}>
				<MaterialIcon className='sync-status__icon' aria-hidden='true'>{icon}</MaterialIcon>
				<span>{line}</span>
			</div>
			}
			{loadError !== null &&
			<div className='sync-status__line is-error' title={loadError || undefined}>
				<MaterialIcon className='sync-status__icon' aria-hidden='true'>error_outline</MaterialIcon>
				<span>{LOAD_FAILED}</span>
			</div>
			}
			{!persistent &&
			<div className='sync-status__line is-warning'>
				<MaterialIcon className='sync-status__icon' aria-hidden='true'>warning</MaterialIcon>
				<span>{NOT_PERSISTENT}</span>
			</div>
			}
			{rejected.length > 0 &&
			<div className='sync-status__rejected'>
				<div className='sync-status__line is-error'>
					<MaterialIcon className='sync-status__icon' aria-hidden='true'>error_outline</MaterialIcon>
					<span>{rejectedHeading(rejected.length)}</span>
				</div>
				<ul className='sync-status__list'>
					{rejected.map((entry) => (
						<li key={entry.client_id} className='sync-status__entry'>
							<span className='sync-status__description'>
								{describeOp(entry, entities)}
								{entry.error ? <span className='sync-status__error'>{entry.error}</span> : null}
							</span>
							<button
								type='button'
								className='shell-control sync-status__dismiss'
								onClick={() => dispatch(dismissRejectedFoodOps([entry.client_id]))}
							>
								Dismiss
							</button>
						</li>
					))}
				</ul>
			</div>
			}
		</div>
	);
}
